import * as React from "react";
import { useState, useCallback, useEffect } from "react";
import {
  ExpansionPanel,
  ExpansionPanelContent,
} from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { Tile } from "components/UIComponents/Tile";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";

const OpenMatter = ({ formData, setHandlefn }) => {
  console.log(formData);
  const data = [
    {
      id: "Client",
      label: "Client Details",
      content: (
        <>
          <Label>Client Name: </Label>
          <p>{formData?.clientData?.clientName}</p>
        </>
      ),
      expanded: true,
    },
    {
      id: "Matter",
      label: "Matter Details",
      content: (
        <>
          <Label>Matter Ref: </Label>
          <p>{formData?.matterDetails?.matterRef}</p>
        </>
      ),
      expanded: true,
    },
    {
      id: "Conflict",
      label: "Conflict Check",
      expanded: false,
    },
    {
      id: "Risk",
      label: "Risk Assessment",
      content: (
        <>
          <Label>Status: </Label>
          <p>{formData?.riskAssessment?.status}</p>
        </>
      ),
      expanded: true,
    },

    {
      id: "Engagement",
      label: "Engagement Letter",
    },
    {
      id: "Tasks",
      label: "Client Task Details",
      expanded: true,
    },
  ];
  const [expanded, setExpanded] = useState("Client");

  const handleNext = useCallback(() => {
    console.log('Open Matter clicked');
  }, []);

  useEffect(() => {
    if (setHandlefn) {
      setHandlefn(() => handleNext);
      return () => setHandlefn && setHandlefn(null);
    }
  }, [setHandlefn, handleNext]);


  return (
    <div className="">
      <Tile
        heading="Matter Opening"
        height={"calc(100vh -  305px)"}
        className="p-3 ps-4 pe-4 pt-2 pb-0 overflow-auto bg-transparent border-0 border w-100 shadow-none"
      >
        <div
          className="d-flex flex-column justify-content-between"
          style={{ height: "calc(100vh -  380px)" }}
        >
          <div>
            {data.map((item) => (
              <ExpansionPanel
                title={item.label}
                expanded={expanded === item.id}
                tabIndex={0}
                key={item.id}
                onAction={(event) => {
                  if (item.expanded) {
                    setExpanded(event.expanded ? "" : item.id);
                  }
                }}
                expandIcon={item.expanded ? undefined : () => null} // Remove icon if not expandable
              >
                <Reveal>
                  {expanded === item.id && (
                    <ExpansionPanelContent>
                      <div className="content">
                        <span className="content-text">{item.content}</span>
                      </div>
                    </ExpansionPanelContent>
                  )}
                </Reveal>
              </ExpansionPanel>
            ))}
          </div>

         
        </div>
      </Tile>
    </div>
  );
};
export default OpenMatter;
